import { Accordion, Tab } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import usePreventClickjacking from 'helpers/hooks/usePreventingClickjacking';
import useUser from 'helpers/hooks/useUser';
import { UserModule } from 'models/user/sso';
import FileContent from './acordion/fileContent';
import PortalMessage from './acordion/portalMessage';
import { useEffect } from 'react';

function Manual(): JSX.Element {
  const { t } = useTranslation();
  const { user: userDetails } = useUser();
  usePreventClickjacking();

  if (!userDetails) return <></>;

  const userModules = userDetails.module;
  const isSuperAdmin = userDetails.role === "1" ? true : false;

  const tabPanes = [];

  if (userModules?.includes(UserModule.RMA.toString())) {
    tabPanes.push(
      <Tab.Pane key="rma" title={t('manual.RepairCenter')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <FileContent section={'REPAIRCENTER'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  if (userModules?.includes(UserModule.SPAREPARTS.toString())) {
    tabPanes.push(
      <Tab.Pane key="spareparts" title={t('manual.SpareParts')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <FileContent section={'SPAREPARTS'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  if (userModules?.includes(UserModule.HSL_WEB.toString())) {
    tabPanes.push(
      <Tab.Pane key="hsl" title={t('manual.HSL')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <FileContent section={'HSLWEB'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  if (userModules?.includes(UserModule.MAINTENANCE_REPORT.toString())) {
    tabPanes.push(
      <Tab.Pane key="maintenance" title={t('manual.MaintenanceReport')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <FileContent section={'MAINTENANCEREPORT'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  if (userModules?.includes(UserModule.USER.toString())) {
    tabPanes.push(
      <Tab.Pane key="user" title={t('manual.User')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <FileContent section={'USER'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  if (userModules?.includes(UserModule.USER.toString()) && isSuperAdmin) {
    tabPanes.push(
      <Tab.Pane key="user" title={t('manual.Message')}>
        <Accordion>
          <Accordion.Content title={t('manual.Files')}>
            <PortalMessage section={'USER'} />
          </Accordion.Content>
        </Accordion>
      </Tab.Pane>
    );
  }

  return (
    <div className="container">
      <Tab>{tabPanes}</Tab>
    </div>
  );
}

export default Manual;